import { auth } from "./firebase";
import { store } from "../store";

let cachedToken = null;
let tokenExpiry = null;

export const getIdentityToken = async () => {
  const u = auth.currentUser;
  if (!u) {
    const state = store.getState();
    return state?.session?.identityToken || null;
  }

  const now = Date.now();
  if (cachedToken && tokenExpiry && now < tokenExpiry) {
    return cachedToken;
  }

  cachedToken = await u.getIdToken(true);
  tokenExpiry = now + 55 * 60 * 1000;
  return cachedToken;
};